import { brandEntityId, BrandEntityId, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandUseRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandUseRequest) {
    JsonSchemaValidator.assert(RoomBrandUseRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId"],
      properties: {
        roomId,
        brandId: brandEntityId
      }
    };
  }
}

interface RoomBrandUseRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
}
